import styled from 'styled-components';
import Button from 'src/components/core/button';
import { KIOSK_PRO_MEDIA } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-shared.styles';

export const PhoneNumberContainer = styled.div`
  padding: 72px;
  text-align: center;
  width: 100%;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding: 56px;
  }
`;

export const Title = styled.h1`
  font-size: clamp(46px, 11.46vw, 56px);
  margin: 0 auto 56px;
  max-width: 800px;

  @media (orientation: portrait) {
    margin-bottom: 72px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 40px;
    margin-bottom: 40px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    margin-bottom: 56px;
  }
`;

export const PhoneNumberPadWrapper = styled.div`
  width: 380px;
  margin: 0 auto;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 260px;
  }
`;

export const PhoneNumberPadGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 8px;
`;

export const BottomRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    gap: 8px;
  }

  > :first-child {
    justify-self: end;
    margin: 0;
  }

  > :last-child {
    justify-self: start;
    margin: 0;
  }
`;

export const Number = styled.button`
  width: 112px;
  height: 112px;
  border: 2px solid ${({ theme }) => theme.customized.colors.buttonsLinks};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  margin: 0 auto;
  font-size: 36px;
  font-weight: bold;
  cursor: pointer;
  display: grid;
  place-items: center;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 80px;
    height: 80px;
    font-size: 24px;
  }
`;

export const PhoneNumberInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 56px;
  min-height: 112px;

  @media (orientation: portrait) {
    margin-bottom: 72px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    min-height: 80px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    margin-bottom: 56px;
  }
`;

export const PhoneNumberDisplay = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const PhoneNumberText = styled.span`
  font-size: 112px;
  font-weight: bold;
  white-space: pre;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 80px;
  }
`;

export const ReadOnlyInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

export const BlinkingCursor = styled.span`
  font-size: 112px;
  font-weight: bold;
  color: #000;
  animation: blink 1s infinite;
  pointer-events: none;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 80px;
  }

  @keyframes blink {
    0%,
    50% {
      opacity: 1;
    }
    51%,
    100% {
      opacity: 0;
    }
  }
`;

export const EnterButton = styled(Button)`
  display: inline-block;
  margin: 36px 0 0 0;
  padding: 36px 56px;
  line-height: 15px;
  font-weight: 700;
  font-size: 36px;
  width: 380px;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 28px;
    padding: 28px 40px;
    width: 320px;
  }
`;
